import { render } from "./ServerManager.vue?vue&type=template&id=52cfc760"
import script from "./ServerManager.vue?vue&type=script&lang=js"
export * from "./ServerManager.vue?vue&type=script&lang=js"

import "./ServerManager.vue?vue&type=style&index=0&id=52cfc760&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__